import { Controller } from "react-hook-form";
import { Breadcrumbs, ClickAwayListener, Grow, Link, MenuItem, MenuList, Paper, Popper, Stack, Typography } from "@mui/material";
import { useGruposAcessoCadastroViewModel } from "../../viewModels/grupos_acesso_cadastro_view_model";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import SwitchPrimary from "../../../../../common/components/switch_primary";
import AlertError from "../../../../../common/components/alert_error";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import FormContainer from "../../../../../common/components/form_container";
import BottomBar from "../../../../../common/components/bottom_bar";
import LoadingPage from "../../../../../components/global/LoadingPage";
import { DropDownFuncionario } from "../../../../../common/components/dropdown_funcionario";
import { TabelaAtribuicoesGrupo } from "./components/tabela_atribuicoes_grupo";
import { Link as LinkTo } from "react-router";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { BackButton } from "../../../../../common/components/back_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";

/**
 * GruposAcessoCadastro
 */

export const GruposAcessoCadastro = () => {
  const viewModel = useGruposAcessoCadastroViewModel();

  return (
    <>

      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row w-full justify-end gap-2">
              <BackButton onClick={() => viewModel.handlePageBack()} />
              <div>
                <Stack direction="row" spacing={2}>

                  <div className="w-[12rem]">
                    <PrimaryButton
                      ref={viewModel.menuRef}
                      id="composition-button"
                      aria-controls={viewModel.openMenu ? "composition-menu" : undefined}
                      aria-expanded={viewModel.openMenu ? "true" : undefined}
                      aria-haspopup="true"
                      onClick={viewModel.handleToggleMenu}
                      buttonColor="primary-green"
                    >
                      Opções
                    </PrimaryButton>
                    <Popper
                      style={{ zIndex: 10000 }}
                      open={viewModel.openMenu}
                      anchorEl={viewModel.menuRef.current}
                      placement="bottom-start"
                      transition
                      disablePortal
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          style={{
                            transformOrigin:
                              placement === "bottom-start" ? "left top" : "left bottom"
                          }}
                        >
                          <Paper>
                            <ClickAwayListener onClickAway={viewModel.handleCloseMenu}>
                              <MenuList
                                autoFocusItem={viewModel.openMenu}
                                id="composition-menu"
                                aria-labelledby="composition-button"
                                onKeyDown={viewModel.handleListKeyDown}
                              >
                                <MenuItem onClick={() => viewModel.handleNewGrupo()}>Novo Grupo de Acesso</MenuItem>
                                <MenuItem onClick={() => viewModel.handleGrupoAcessoDeleteOpenState(true)}>Excluir </MenuItem>
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </div>
                </Stack>
              </div>
            </div>
          }
        />
      </PageTopBar>

      <form className="pb-8" onSubmit={viewModel.handleGrupoAcessoCadastroSubmit}>

        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit" >
              Administração
            </Link>
            <Link underline="hover" color="inherit" component={'span'}>
              <LinkTo to="/GruposAcesso_lista"> Grupos Acesso Lista</LinkTo>
            </Link>
            <Typography className="text-primary-green">
              Cadastro
            </Typography>
          </Breadcrumbs>


          {
            viewModel.errorMessage !== undefined
              ? (
                <div className="w-full">
                  <AlertError
                    messageErro={viewModel.errorMessage ?? ""}
                    onTryAgain={() => { }} />
                </div>
              ) : (
                <>
                  {viewModel.loading === false
                    ? (
                      <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
                        <FormContainer title={"Informações básicas"} arrangement="fullRow">
                          <>
                            <div className="w-full flex justify-start">
                              <Controller
                                name="ativo"
                                control={viewModel.hookForm.control}
                                render={(({ field: { onChange, value } }) => (
                                  <SwitchPrimary
                                    checked={value}
                                    onChange={onChange}
                                    label={value === true ? "Ativo" : "Bloqueado"}
                                    labelPlacement="end" />)
                                )} />
                            </div>

                            <div className="w-[60%]">
                              <DefaultFormInput
                                name={'nomeGrupo'}
                                label={"Grupo"}
                                required={true}
                                reactHookForm={viewModel.hookForm}
                              />
                            </div>



                            <div className="w-[60%]">
                              <DefaultFormInput
                                name={'descricao'}
                                label={"Descrição"}
                                required={false}
                                multiline={true}
                                minRows={2}
                                maxRows={4}
                                reactHookForm={viewModel.hookForm}
                              />
                            </div>


                            <div className="w-full flex flex-col gap-4 mt-3 justify-start items-start md:items-center md:flex-row">
                              <div className="w-[60%]">
                                <DropDownFuncionario
                                  name='gestorGrupo'
                                  label='Gestor do Grupo'
                                  required={false}
                                  readOnly={false}
                                  reactHookForm={viewModel.hookForm}
                                />
                              </div>
                            </div>

                          </>
                        </FormContainer>

                        <div className="w-full m-3">
                          <TabelaAtribuicoesGrupo
                            loading={viewModel.loading}
                            saving={false}
                            gridRowSelectionModel={viewModel.atribuicaoGrupoSelectionModel ?? { type: 'include', ids: new Set() }}
                            atribuicoesGrupo={viewModel.atribuicaoGrupoLista ?? []}
                            page={viewModel.pagination.page}
                            rowsPerPage={viewModel.pagination.rowsPerPage}
                            totalItems={viewModel.pagination.totalItems}
                            onPageChange={viewModel.handlePageChange}
                            onRowsPerPageChange={viewModel.handleRowsPerPageChange}
                            onSelectionModelChange={viewModel.handleAtribuicaoSelectionModelChange}

                          />

                        </div>

                      </div>
                    )
                    : (
                      <LoadingPage />
                    )
                  }
                </>
              )
          }
        </div>

        {viewModel.loading === false &&
          <BottomBar>
            <div className="w-full h-full items-center justify-end flex p-4 gap-4">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={viewModel.handlePageBack}>
                  Cancelar
                </h1>
              </div>
              <div className="w-40">
                {viewModel.saving ? (
                  <PrimaryButton>Salvando...</PrimaryButton>
                ) : (
                  <PrimaryButton
                    type="submit"
                    startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}
                  >
                    Salvar
                  </PrimaryButton>
                )}
              </div>
            </div>
          </BottomBar>
        }
      </form>
      <DeleteDialog
        open={viewModel.openDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleGrupoAcessoDeleteOpenState(false)}
        title="Você realmente deseja excluir este Grupo de Acesso?"
        onDelete={viewModel.handleConfirmarDeletarGrupoAcesso}
      />
    </>
  );
}